import React from "react";

const initialsFor = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return parts.slice(0, 2).map((p) => p[0]).join("").toUpperCase();
};

const ProofAvatar = ({ proof, size = 40, ringColor = "#0f172a", className = "" }) => {
  const dim = `${size}px`;
  if (proof.avatar) {
    return (
      <img
        src={proof.avatar}
        alt={proof.name || ""}
        loading="lazy"
        className={`flex-none object-cover ${className}`}
        style={{
          width: dim,
          height: dim,
          borderRadius: "9999px",
          border: `2px solid ${ringColor}`,
        }}
      />
    );
  }
  return (
    <div
      className={`flex-none flex items-center justify-center font-black text-white bg-slate-700 ${className}`}
      style={{
        width: dim,
        height: dim,
        borderRadius: "9999px",
        border: `2px solid ${ringColor}`,
        fontSize: `${Math.round(size / 2.5)}px`,
      }}
      aria-hidden="true"
    >
      {initialsFor(proof.name)}
    </div>
  );
};

export default ProofAvatar;
